let tabsNav = document.querySelectorAll('.block_tabs_text .tabs-nav li');
let tabPanels = document.querySelectorAll('.block_tabs_text .tab-panel');

tabsNav.forEach(function (el) {
    //Get correct tab id
    let tabId = el.getAttribute('data-tab');

    el.addEventListener('click', function () {
        //Remove all active classes from the tabs nav items
        tabsNav.forEach(function (el) {
            el.classList.remove('is-active');
        });

        //Remove all active classes from the tab panels
        tabPanels.forEach(function (el) {
            el.classList.remove('is-active');
            el.querySelector('.tab-content').style.display = 'none';
        });

        //Set active classes
        this.classList.add('is-active');
        document.getElementById(tabId).parentElement.classList.add('is-active');

        //Trigger click the js-accordion class because footer accordion script is used here
        document.getElementById(tabId).click();
    });
});
